export enum NumbersRoutes {
  root = 'organization/numbers',
}
